export const environment = {
  production: false,
  url: 'https://admin.people.test.private.unico.run/svc2',
  url_benefits: 'https://admin.people.test.private.unico.run/api/benefits/v1',
  cdn_url: 'https://admin.people.test.private.unico.run/cdn2',
  identity_url: 'https://identityqa.acesso.io',
  base_url: 'https://benefits.people.test.private.unico.run/',
  sign_url: 'https://sign-core-test.acesso.io',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'owU92MBGE2z1CWhnW1TZ927JDk9M6uUk',
  redirect_uri: 'https://benefits.people.test.private.unico.run/preauthorize',
  admission_url: 'https://admin.people.test.private.unico.run',
  collaborator_url:  'https://collaborators.people.test.private.unico.run',
  sentry_key: 'N/A',
  launchDarklyClientId: '63b870113b5a4212abb0f0fa',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
